<template>
    <div class="site-panel w-100" v-if="tzb" style="position: relative">
        <p-site-tzb-history
            :unit     = "site"
            :current  = "tzb"
            :history  = "history.items"
            v-model   = "history.show"
            @selected = "onSelected"
        />

        <p-site-tzb-reports
            v-model   = "reports.show"
            :menu     = "reports.items"
            @selected = "onPrint"
        />

        <v-row class="no-frame">
            <v-col class="main-first-col no-border">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-elevator-general
                        :data     = "tzb"
                        :readonly = "readonly"
                        :extended = "extended"
                    />
                </v-row>

                <v-row class="no-frame mt-5">
                    <c-site-tzb-elevator-maintenance
                        :data          = "tzb.maintenance"
                        :zus-inspection = "tzb.zusInspection"
                        :readonly       = "readonly"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-elevator-gadget
                        :title  = "$t('unit.tzb.engine.title')"
                        :label  = "$t('unit.tzb.engine.label')"
                        :gadget = "tzb.engine"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="main-middlle-col no-border" style="padding-right: 1px">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-elevator-gadget
                        :title  = "$t('unit.tzb.automatic.title')"
                        :label  = "$t('unit.tzb.automatic.label')"
                        :gadget = "tzb.automatic"
                        :extended = "extended"
                        :readonly = "readonly"
                    >
                        <template v-slot:additional>
                            <v-row class="no-frame mt-1">
                                <f-read-only-field
                                    :value        = "site.specification.collectiveControlType ? site.specification.collectiveControlType.name : '---' "
                                    :label        = "$t('unit.tzb.automatic.subtitle')"
                                    class         = "w-100"
                                    :line  = "false"
                                    dense
                                />
                            </v-row>
                        </template>
                    </c-site-tzb-elevator-gadget>
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-elevator-gadget
                        :title  = "$t('unit.tzb.control.title')"
                        :label  = "$t('unit.tzb.control.label')"
                        :gadget   = "tzb.control"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-elevator-gadget
                        :title  = "$t('unit.tzb.manholeDoor.title')"
                        :label  = "$t('unit.tzb.manholeDoor.label')"
                        :gadget = "tzb.liftShaftDoor"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="main-middlle-col no-border">
                <v-row class="no-frame mt-2">
                    <v-col class="no-frame col-12">
                        <c-site-tzb-car
                            :data="tzb.car"
                            :extended = "extended"
                            :readonly = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-5">
                    <v-col class="no-frame col-12">
                        <c-site-tzb-elevator-gadget
                            :title    = "$t('unit.tzb.speedLimiter.title')"
                            :label    = "$t('unit.tzb.speedLimiter.label')"
                            :sublabel = "$t('unit.tzb.speedLimiter.sublabel')"
                            :gadget   = "tzb.speedLimiter"
                            :extended = "extended"
                            :readonly = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-5">
                    <v-col class="no-frame col-12">
                        <c-site-tzb-elevator-gadget
                            :title  = "$t('unit.tzb.saftyCatch.title')"
                            :label  = "$t('unit.tzb.saftyCatch.label')"
                            :gadget = "tzb.saftyCatch"
                            :extended = "extended"
                            :readonly = "readonly"
                        />
                    </v-col>
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="main-last-col no-border">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-elevator-gadget
                        :title    = "$t('unit.tzb.doorDrive.title')"
                        :label    = "$t('unit.tzb.doorDrive.label')"
                        :sublabel = "$t('unit.tzb.doorDrive.sublabel')"
                        :gadget   = "tzb.doorDrive"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-elevator-gadget
                        :title  = "$t('unit.tzb.emcSystem.title')"
                        :label  = "$t('unit.tzb.emcSystem.label')"
                        :gadget = "tzb.emcSystem"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CSiteTzbElevatorGeneral     from "@/modules/msd/unit/components/dialog/CSiteTzbElevatorGeneral";
import CSiteTzbElevatorGadget      from "@/modules/msd/unit/components/dialog/CSiteTzbElevatorGadget";
import CSiteTzbCar                 from "@/modules/msd/unit/components/dialog/CSiteTzbCar";
import CSiteTzbElevatorMaintenance from "@/modules/msd/unit/components/dialog/CSiteTzbElevatorMaintenance";
import CVSpacer                    from "@/modules/core/components/utils/CVSpacer";
import PSiteTzbHistory             from "@/modules/msd/unit/components/dialog/private/PSiteTzbHistory.vue";
import Site                        from "@/modules/msd/unit/service/Site";
import FReadOnlyField              from "@/modules/core/components/utils/FReadOnlyField.vue";
import PSiteTzbReports             from "@/modules/msd/unit/components/dialog/private/PSiteTzbReports.vue";

export default {
    name: "TSiteTzbElevator",

    components: {
        PSiteTzbReports,
        FReadOnlyField,
        PSiteTzbHistory,
        CVSpacer,
        CSiteTzbElevatorGeneral,
        CSiteTzbElevatorMaintenance,
        CSiteTzbCar,
        CSiteTzbElevatorGadget,
    },

    props: {
        site: {

        },

        readonly: {

        }
    },

    data: () => ({
        history: {
            show : false,
            items: null,
        },

        tzb: null,
        reports: {
            show : false,
            items: null,
        },
    }),

    computed: {
        extended () {
            return this.site && this.site.customer.extendedConditions;
        },
    },

    mounted() {
        this.reports.items = [];
        this.reports.items.push({ id: 114, name: "Zustandsbericht"})
        this.load();
    },

    watch: {
        site () {
            this.load();
        }
    },

    methods: {
        load () {
            if (!this.site) {
                return;
            }

            Site.condition.history(this.site).then(history => {
                this.history.items = history;
                this.loadTzb(this.history.items[0].id);
            });
        },

        loadTzb (id) {
            Site.condition.load (this.site, id).then(tzb => {
                this.tzb = tzb;
            })
        },

        onSelected (item) {
            this.loadTzb(item.id);
        },

        onReports () {
            this.reports.show = true;
        },

        onPrint (report) {
            Site.condition.report(this, report.id, this.tzb.id, report.name);
        },

        onHistory () {
            this.history.show = true;
        },
    }
}
</script>

<style scoped>

::v-deep .tzb-gadget {
    min-height: 200px;
}

::v-deep .readonly-value {
    padding-left: 0 !important;
    padding-top: 0 !important;
}

</style>